"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelsManager = void 0;
const api_1 = require("client/api");
const store_1 = require("client/modules/inventory/modules/inventory-detail/store");
const print_manager_1 = require("client/modules/labels/print-labels/print-manager");
const store_2 = require("client/modules/labels/store");
const jsBarcode = require("jsbarcode");
const mobx_1 = require("mobx");
const printOptionsDummy = {
    claimLabel: false,
    invoice: false,
    monograph: false,
    patientWaiver: false,
    warningLabel: false,
    pharmacyLabel: false
};
// Transparent PNG base 64 Encoding
const defaultWhitePng = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=`;
class LabelsManager {
    constructor() {
        this.createPng = async (claim) => new Promise((resolve, reject) => {
            const barcode = claim.inventory.barCode;
            const canvas = document.createElement("canvas");
            jsBarcode(canvas, barcode, { format: "code128" });
            return resolve(canvas.toDataURL("image/png"));
        });
        this.saveToDB = async (printMeta, claim, order) => {
            try {
                await store_2.labelsStore.attemptPassToServer(print_manager_1.printManager.initiatePrint([printMeta]), String(claim.rxId.rxId), String(order.site.id));
            }
            catch (err) {
                console.error("Error on attemptPassToServer", err);
            }
        };
        this.print = async (claims, type) => {
            const labelStack = await this.generateLabelStack(claims, type);
            await this.printLabels(labelStack, type);
        };
        this.generatePrintOptions = (type) => {
            let printOptions = Object.assign({}, printOptionsDummy);
            switch (type) {
                case "all":
                case "documents":
                case "saveToDB":
                    printOptions = Object.assign(Object.assign({}, printOptions), { 
                        // billingSheet: true,
                        claimLabel: true, invoice: true, monograph: true, patientWaiver: true, warningLabel: true, pharmacyLabel: true });
                    break;
                case "labels":
                    printOptions = Object.assign(Object.assign({}, printOptions), { pharmacyLabel: true });
                    break;
                case "receipt": // D-002.60 add case to print only the receipt page
                    printOptions = Object.assign(Object.assign({}, printOptions), { receipt: true // D-002.60
                     });
                    break;
                default:
                    break;
            }
            return printOptions;
        };
        this.generateLabelStack = async (claims, type, printOptionsOverride) => {
            await store_2.labelsStore.listClaimNdcMonographs(claims);
            const claimNdcMonographs = store_2.labelsStore.claimNdcMonographs;
            const printOptions = printOptionsOverride || this.generatePrintOptions(type);
            const labelStack = await Promise.all(claimNdcMonographs.map(async ([monograph, claim]) => {
                const png = await this.createPng(claim);
                return {
                    claim,
                    monograph,
                    png,
                    printOptions
                };
            }));
            return labelStack;
        };
        this.generatePrintMeta = (labelStack, type) => {
            return labelStack.map(async (label) => {
                const { claim, monograph, png, printOptions } = label;
                const parsedMonograph = print_manager_1.printManager.parseMonograph(monograph);
                const patientSignature = claim.signature
                    ? await print_manager_1.printManager.convertPng(claim.signature)
                    : defaultWhitePng;
                const barcode = await print_manager_1.printManager.convertPng(png);
                const providerSignature = await print_manager_1.printManager.convertPng(claim.order.provider.signature);
                await store_1.inventoryDetailStore.readInventory(claim.inventory.id);
                const icd10sRaw = store_1.inventoryDetailStore.icd10List.map((icd10) => icd10.Code);
                const icd10s = icd10sRaw.join(", ");
                let historic;
                const getData = await api_1.OrderEndpoint.historicClaimData.apiCall(null, {
                    claimId: claim.id
                });
                if (api_1.isError(getData)) {
                    console.log("Using legacy data access.");
                }
                else {
                    historic = getData.response;
                }
                const printMeta = {
                    claim,
                    historic,
                    monograph: parsedMonograph,
                    barcode,
                    providerSignature,
                    patientSignature,
                    printOptions,
                    icd10s
                };
                if (type === "saveToDB") {
                    await this.saveToDB(printMeta, claim, claim.order);
                }
                return printMeta;
            });
        };
        this.printLabels = async (labelStack, type) => {
            // Generate print meta
            const printMetas = await Promise.all(this.generatePrintMeta(labelStack, type));
            const pdfStack = print_manager_1.printManager.initiatePrint(printMetas);
            const pdf = window.pdfMake.createPdf(pdfStack);
            pdf.open();
            try {
                pdf.getDataUrl((dataUrl) => {
                    console.info("final data to be used ready");
                });
            }
            catch (err) {
                console.error("err in getDataUrl", err);
            }
        };
    }
}
__decorate([
    mobx_1.action
], LabelsManager.prototype, "createPng", void 0);
__decorate([
    mobx_1.action
], LabelsManager.prototype, "saveToDB", void 0);
__decorate([
    mobx_1.action
], LabelsManager.prototype, "print", void 0);
__decorate([
    mobx_1.action
], LabelsManager.prototype, "generatePrintOptions", void 0);
__decorate([
    mobx_1.action
], LabelsManager.prototype, "generateLabelStack", void 0);
__decorate([
    mobx_1.action
], LabelsManager.prototype, "generatePrintMeta", void 0);
exports.labelsManager = new LabelsManager();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/labels-manager/labels-manager.ts
// module id = 2697
// module chunks = 0 1